function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function FavouriteActive(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 33 32",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17 0a16 16 0 10-.015 32A16 16 0 0017 0zm.31 22.44l-.41.33-.4-.33c-5.28-4.29-6.78-5.87-6.83-8.36a4 4 0 011-2.77 3.9 3.9 0 012.6-1.31 4.36 4.36 0 013.63 1.55 4.33 4.33 0 011.63-1.21 4.43 4.43 0 012-.34 3.94 3.94 0 013.61 4.07c-.06 2.5-1.56 4.08-6.83 8.37z",
    fill: props.color || "#5C50BB"
  }));
}
const MemoFavouriteActive = /*#__PURE__*/React.memo(FavouriteActive);
export default MemoFavouriteActive;